var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div> This is a test "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"testVar") || (depth0 != null ? lookupProperty(depth0,"testVar") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"testVar","hash":{},"data":data,"loc":{"start":{"line":1,"column":21},"end":{"line":1,"column":32}}}) : helper)))
    + " </div>";
},"useData":true});